import { RouteConfig } from 'vue-router'
import LoginView from '@/views/LoginView.vue'
import LogoutView from '@/views/LogoutView.vue'
import DashboardView from '@/views/DashboardView.vue'
import TrainingLoadView from '@/views/TrainingLoadView.vue'
import PlayerDetailsView from '@/views/PlayerDetailsView.vue'
import EventsView from '@/views/EventsView.vue'
import AdminPlayersView from '@/views/admin/AdminPlayersView.vue'
import AdminTeamsView from '@/views/admin/AdminTeamsView.vue'
import AdminStaffView from '@/views/admin/AdminStaffView.vue'
import AdminLocationsView from '@/views/admin/AdminLocationsView.vue'
import DiagnosticProtocolsView from '@/views/DiagnosticProtocolsView.vue'
import AdminPlayerForm from '@/views/admin/AdminPlayerForm.vue'
import AdminPlayerEditForm from '@/views/admin/AdminPlayerEditForm.vue'
import AdminDevicesView from '@/views/admin/AdminDevicesView.vue'
import AdminMembershipPlansView from '@/views/admin/AdminMembershipPlansView.vue'
import AdminParentsView from '@/views/admin/AdminParentsView.vue'
import ForgotPasswordView from '@/views/ForgotPasswordView.vue'
import DiagnosticsView from '@/views/DiagnosticsView.vue'
import MembershipFeesView from '@/views/MembershipFeesView.vue'
import AdminPolarTeamView from '@/views/admin/AdminPolarTeamView.vue'
import AdminGpexeView from '@/views/admin/AdminGpexeView.vue'
import TrainingProtocolsView from '@/views/TrainingProtocolsView.vue'
import TrainingExercisesView from '@/views/TrainingExercisesView.vue'
import AdminFieldwizView from '@/views/admin/AdminFieldwizView.vue'
import AdminCatapultView from '@/views/admin/AdminCatapultView.vue'
import MedicalView from '@/views/MedicalView.vue'
import InsidersHubView from '@/views/InsidersHubView.vue'
import DrillListView from '@/views/DrillListView.vue'
import DashboardPlayersView from '@/views/DashboardPlayersView.vue'
import LineupsView from '@/views/LineupsView.vue'
import TrainingProgramsView from '@/views/TrainingProgramsView.vue'
import TrainingProgramInstancesView from '@/views/TrainingProgramInstancesView.vue'
import i18n from '@/plugins/i18n'
import AdminPerformanceView from '@/views/admin/AdminPerformanceView.vue'
import PerformanceEventView from '@/views/PerformanceEventView.vue'
import PerformanceAdvancedView from '@/views/PerformanceAdvancedView.vue'
import PerformanceWeeklyView from '@/views/PerformanceWeeklyView.vue'
import DiagnosticComparisonView from '@/views/DiagnosticComparisonView.vue'

export const RouteNames = {
  LOGIN: 'login',
  LOGOUT: 'logout',
  CREATE_PASSWORD: 'createPassword',
  DASHBOARD: 'dashboard',
  DASHBOARD_PLAYERS: 'dashboardPlayers',
  LINEUPS: 'lineups',
  TRAINING_LOAD: 'trainingLoad',
  PERFORMANCE_EVENT: 'performanceEvent',
  PERFORMANCE_WEEKLY: 'performanceWeekly',
  PERFORMANCE_ADVANCED: 'performanceAdvanced',
  DIAGNOSTICS: 'diagnostics',
  DIAGNOSTIC_PROTOCOLS: 'diagnosticProtocols',
  DIAGNOSTIC_COMPARISON: 'diagnosticComparison',
  MEDICAL: 'medical',
  PLAYER_DETAILS: 'playerDetails',
  EVENTS: 'events',
  ADMIN_PLAYERS: 'adminPlayers',
  ADMIN_TEAMS: 'adminTeams',
  ADMIN_STAFF: 'adminStaff',
  ADMIN_LOCATIONS: 'adminLocations',
  ADMIN_PLAYER_FORM: 'adminPlayerForm',
  ADMIN_PLAYER_EDIT: 'adminPlayerEdit',
  ADMIN_DEVICES: 'adminDevices',
  ADMIN_MEMBERSHIP_PLANS: 'adminMembershipPlans',
  ADMIN_PARENTS: 'adminParents',
  ADMIN_POLAR_TEAM: 'adminPolarTeam',
  ADMIN_GPEXE: 'adminGpexe',
  ADMIN_FIELDWIZ: 'adminFieldwiz',
  ADMIN_CATAPULT: 'adminCatapult',
  ADMIN_PERFORMANCE: 'adminPerformance',
  FORGOT_PASSWORD: 'forgotPassword',
  FINISH_SIGNUP: 'finishSignup',
  MEMBERSHIP_FEES: 'membershipFees',
  TRAINING_PROTOCOLS: 'trainingProtocols',
  TRAINING_EXERCISES: 'trainingExercises',
  INSIDERS_HUB: 'insidersHub',
  DRILL_BUILDER: 'drillBuilder',
  TRAINING_PROGRAMS: 'trainingPrograms',
  TRAINING_PROGRAM_INSTANCES: 'trainingProgramInstances'
}

declare module 'vue/types/vue' {
  interface Vue {
    $routeNames: typeof RouteNames;
  }
}

const routes: RouteConfig[] = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: RouteNames.LOGIN,
    component: LoginView
  },
  {
    path: '/logout',
    name: RouteNames.LOGOUT,
    component: LogoutView
  },
  {
    path: '/signup/finish',
    name: RouteNames.FINISH_SIGNUP,
    component: ForgotPasswordView
  },
  {
    path: '/reset-password',
    alias: '/forgot-password',
    name: RouteNames.FORGOT_PASSWORD,
    component: ForgotPasswordView
  },
  {
    path: '/players/:id',
    name: RouteNames.PLAYER_DETAILS,
    component: PlayerDetailsView,
    meta: {
      crumb: i18n.t('crumb.players')
    }
  },
  {
    path: '/dashboard',
    name: RouteNames.DASHBOARD,
    component: DashboardView,
    meta: {
      crumb: i18n.t('crumb.dashboard')
    }
  },
  {
    path: '/players-list',
    name: RouteNames.DASHBOARD_PLAYERS,
    component: DashboardPlayersView,
    meta: {
      crumb: 'Players List'
    }
  },
  {
    path: '/lineups',
    name: RouteNames.LINEUPS,
    component: LineupsView,
    meta: {
      crumb: 'Lineups'
    }
  },
  {
    path: '/training-load',
    name: RouteNames.TRAINING_LOAD,
    component: TrainingLoadView,
    meta: {
      crumb: i18n.t('crumb.trainingLoad')
    }
  },
  {
    path: '/events',
    name: RouteNames.EVENTS,
    component: EventsView,
    meta: {
      crumb: i18n.t('crumb.events')
    }
  },
  {
    path: '/performance-event',
    name: RouteNames.PERFORMANCE_EVENT,
    component: PerformanceEventView
  },
  {
    path: '/performance-weekly',
    name: RouteNames.PERFORMANCE_WEEKLY,
    component: PerformanceWeeklyView
  },
  {
    path: '/performance-advanced',
    name: RouteNames.PERFORMANCE_ADVANCED,
    component: PerformanceAdvancedView
  },
  {
    path: '/diagnostics',
    name: RouteNames.DIAGNOSTICS,
    component: DiagnosticsView,
    meta: {
      crumb: i18n.t('crumb.diagnostics')
    }
  },
  {
    path: '/diagnostic-protocols',
    name: RouteNames.DIAGNOSTIC_PROTOCOLS,
    component: DiagnosticProtocolsView
  },
  {
    path: '/diagnostic-comparison',
    name: RouteNames.DIAGNOSTIC_COMPARISON,
    component: DiagnosticComparisonView
  },
  {
    path: '/medical',
    name: RouteNames.MEDICAL,
    component: MedicalView,
    meta: {
      crumb: i18n.t('crumb.medical')
    }
  },
  {
    path: '/membership',
    name: RouteNames.MEMBERSHIP_FEES,
    component: MembershipFeesView,
    meta: {
      crumb: i18n.t('crumb.membershipFees')
    }
  },
  {
    path: '/admin/players',
    name: RouteNames.ADMIN_PLAYERS,
    component: AdminPlayersView,
    meta: {
      crumb: i18n.t('crumb.players')
    }
  },
  {
    path: '/admin/teams',
    name: RouteNames.ADMIN_TEAMS,
    component: AdminTeamsView,
    meta: {
      crumb: i18n.t('crumb.teams')
    }
  },
  {
    path: '/admin/staff',
    name: RouteNames.ADMIN_STAFF,
    component: AdminStaffView,
    meta: {
      crumb: i18n.t('crumb.coaches')
    }
  },
  {
    path: '/admin/locations',
    name: RouteNames.ADMIN_LOCATIONS,
    component: AdminLocationsView,
    meta: {
      crumb: i18n.t('crumb.locations')
    }
  },
  {
    path: '/admin/devices',
    name: RouteNames.ADMIN_DEVICES,
    component: AdminDevicesView,
    meta: {
      crumb: i18n.t('crumb.devices')
    }
  },
  {
    path: '/admin/membership-plans',
    name: RouteNames.ADMIN_MEMBERSHIP_PLANS,
    component: AdminMembershipPlansView,
    meta: {
      crumb: i18n.t('crumb.membershipPlans')
    }
  },
  {
    path: '/admin/parents',
    name: RouteNames.ADMIN_PARENTS,
    component: AdminParentsView,
    meta: {
      crumb: i18n.t('crumb.parents')
    }
  },
  {
    path: '/admin/integrations/polar-team',
    name: RouteNames.ADMIN_POLAR_TEAM,
    component: AdminPolarTeamView,
    meta: {
      crumb: i18n.t('crumb.polarTeam')
    }
  },
  {
    path: '/admin/integrations/gpexe',
    name: RouteNames.ADMIN_GPEXE,
    component: AdminGpexeView,
    meta: {
      crumb: i18n.t('crumb.gpexe')
    }
  },
  {
    path: '/admin/integrations/insiders',
    name: RouteNames.ADMIN_FIELDWIZ,
    component: AdminFieldwizView,
    meta: {
      crumb: i18n.t('crumb.fieldWiz')
    }
  },
  {
    path: '/admin/integrations/catapult',
    name: RouteNames.ADMIN_CATAPULT,
    component: AdminCatapultView,
    meta: {
      crumb: i18n.t('crumb.catapult')
    }
  },
  {
    path: '/admin/performance',
    name: RouteNames.ADMIN_PERFORMANCE,
    component: AdminPerformanceView
  },
  {
    path: '/admin/players/add',
    name: RouteNames.ADMIN_PLAYER_FORM,
    component: AdminPlayerForm,
    meta: {
      crumb: i18n.t('crumb.player')
    }
  },
  {
    path: '/admin/players/:id',
    name: RouteNames.ADMIN_PLAYER_EDIT,
    component: AdminPlayerEditForm,
    meta: {
      crumb: i18n.t('crumb.editPlayer')
    }
  },
  {
    path: '/training-protocols',
    name: RouteNames.TRAINING_PROTOCOLS,
    component: TrainingProtocolsView,
    meta: {
      crumb: i18n.t('crumb.trainingProtocols')
    }
  },
  {
    path: '/training-exercises',
    name: RouteNames.TRAINING_EXERCISES,
    component: TrainingExercisesView,
    meta: {
      crumb: i18n.t('crumb.trainingExercises')
    }
  },
  {
    path: '/drill-builder',
    name: RouteNames.DRILL_BUILDER,
    component: DrillListView,
    meta: {
      crumb: 'UX Drill'
    }
  },
  {
    path: '/insiders-hub',
    name: RouteNames.INSIDERS_HUB,
    component: InsidersHubView
  },
  {
    path: '/training-programs',
    name: RouteNames.TRAINING_PROGRAMS,
    component: TrainingProgramsView,
    meta: {
      crumb: i18n.t('sidebar.training_programs.program_library.label')
    }
  },
  {
    path: '/training-program-instances',
    name: RouteNames.TRAINING_PROGRAM_INSTANCES,
    component: TrainingProgramInstancesView,
    meta: {
      crumb: i18n.t('sidebar.training_programs.active_programs.label')
    }
  }

]

export default routes
